import request from '../request';
import requestUrl from '../requestUrl';
import requestParam from '../requestParam';

export const selectInsight = params => {
    return request({
        url: requestUrl('/client/site/selectInsight'),
        method: 'post',
        data: requestParam(params)
    });
};

// 查询课程详情
export const queryCourseDetail = params => {
    return request({
        url: requestUrl('/keeCourse/queryDetail'),
        method: 'get',
        params: params
    });
};

// 查询课程轮播图
export const queryHomeRotate = params => {
    return request({
        url: requestUrl('/keeCourse/queryHomeRotate'),
        method: 'get',
        params: params
    });
};

// 查询课程列表/我的课程/课程收藏
export const queryCourseInfo = params => {
    return request({
        url: requestUrl('/keeCourse/queryInfo'),
        method: 'post',
        data: requestParam(params)
    });
};

// 更新我的收藏
export const updateCollectFlagRecord = params => {
    return request({
        url: requestUrl('/keeCourse/updateCollectFlagRecord'),
        method: 'post',
        data: requestParam(params)
    });
};

// 更新我的课程
export const updateViewFlagRecord = params => {
    return request({
        url: requestUrl('/keeCourse/updateViewFlagRecord'),
        method: 'post',
        data: requestParam(params)
    });
};

// 获取视频token
export const getPlaySafeToken = params => {
    return request({
        url: requestUrl('/keeCourse/polyv/palySalfe/token'),
        method: 'get',
        params: params
    });
};

// 洞察信息数据
export const queryConsult = params => {
    return request({
        url: requestUrl('/csConsult'),
        method: 'get',
    });
};

// 查询课程是否上新
export const queryTagStatus = params => {
    return request({
        url: requestUrl('/keeCourse/queryTagStatus'),
        method: 'get',
    });
};
